import { render } from "./SubstitutesTreeView.vue?vue&type=template&id=6b2a2c55&scoped=true"
import script from "./SubstitutesTreeView.vue?vue&type=script&lang=js"
export * from "./SubstitutesTreeView.vue?vue&type=script&lang=js"

import "./SubstitutesTreeView.vue?vue&type=style&index=0&id=6b2a2c55&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2a2c55"]])

export default __exports__